<template>
 <div style="height: 100%">
   <div>
     <el-date-picker v-fixZoom
       size="small"
       v-model="sendDate"
       type="datetimerange"
       unlink-panels
       range-separator="至"
       start-placeholder="开始日期"
       end-placeholder="结束日期"
       value-format="yyyy-MM-dd HH:mm:ss"
       style="width: 400px;margin-left: 20px"
       :clearable="false">
     </el-date-picker>
     <el-button size="small" type="primary" @click="onSubmit">查询</el-button>
   </div>
   <div style="height: 10px"></div>
   <div style="height: 100%;margin: 0 20px">
     <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="tableData" border style="width: 100%" height="calc(100% - 63px)" highlight-current-row>
       <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
       <el-table-column label="经度" prop="lng" min-width="80" align="center"></el-table-column>
       <el-table-column label="纬度" prop="lat" min-width="80" align="center"></el-table-column>
       <el-table-column label="定位方式" min-width="50" align="center">
         <template slot-scope="scope">
           <span>{{getPType(scope.row)}}</span>
         </template>
       </el-table-column>
       <el-table-column label="定位时间" prop="ptime" min-width="100" align="center"></el-table-column>
     </el-table>
   </div>
   <div style="height: 20px"></div>
 </div>
</template>

<script>
import {querydevicehistoryposition} from '../../../api/device'
export default {
  name: 'historyLocation',
  model: {
    prop: 'hisLocationShow',
    event: 'change'
  },
  props: {
    hisLocationObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      row: '',
      sendDate: [],
      loading: false,
      tableData: []
    }
  },
  created () {
    this.row = this.hisLocationObj.deviceRow
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyy-MM-dd hh:mm:ss')
    this.sendDate = [date, date]
  },
  methods: {
    onSubmit () {
      this.loading = true
      let data = {
        imei: this.row.deviceid,
        from: this.sendDate[0],
        to: this.sendDate[1]
      }
      querydevicehistoryposition(data).then(res => {
        let positionArr = res.data.devicepositions
        this.tableData = positionArr
      }).catch(() => {})
      this.loading = false
    },
    getPType (row) {
      let ptype = row.ptype
      if (ptype === 0) {
        ptype = '基站'
      } else if (ptype === 1) {
        ptype = 'GPS'
      } else if (ptype === 2) {
        ptype = 'WIFI'
      }
      return ptype
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemlog/childComponents/historyLocation.vue